import BuySideInstance from './BuySideInstance.component';

export default BuySideInstance;
